let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3iVDU")).then(() => parcelRequire('hrgZs'));